import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableColumnsType } from 'antd';
import { ISpeakingDetailPaper } from '../../../../models/newSpeaking.model';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';
import { getDetailCode } from '../../../../lib/util';
import Button from '../../../../components/Button';
import useAuth from '../../../../hooks/useAuth';

interface IProps {
  data?: ISpeakingDetailPaper[];
  speakingExamCode: number;
}

interface ITableSpeakingDetailPaper extends Partial<ISpeakingDetailPaper> {}

const SpeakingPartTable: FC<IProps> = ({ data, speakingExamCode }) => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);

  const [tableData, setTableData] = useState<ITableSpeakingDetailPaper[]>([]);

  const TE0002 = getDetailCode(commonCodes, 'TE0002');

  const columns: TableColumnsType<ITableSpeakingDetailPaper> = [
    {
      title: 'Part',
      dataIndex: 'speakingPartCode',
      key: 'speakingPartCode',
      align: 'center',
      render: (value, record, index) => TE0002[index].korName,
    },
    {
      title: t('cbt.speakTest.column1'),
      dataIndex: 'partName',
      key: 'partName',
      align: 'center',
      render: (value?: string) =>
        !value ? (
          <Button
            className="btn btn-sm btn-secondary btn-w55p"
            onClick={() =>
              history.push(`/cbt/speaking-test/${speakingExamCode}/part/create`)
            }
            text={t('common.button.add')}
            writeAuthYn={writeAuthYn}
          />
        ) : (
          value
        ),
    },
    {
      title: t('cbt.speakTest.column8'),
      dataIndex: 'rubricName',
      key: 'rubricName',
      align: 'center',
    },
  ];

  useEffect(() => {
    console.log('data: ', data);
    if (data) {
      const newTableData: ITableSpeakingDetailPaper[] = [...data];
      if (newTableData.length < 2) {
        const length = newTableData.length;
        for (let i = 0; i < 2 - length; i++) newTableData.push({});
      }
      setTableData(newTableData);
    }
  }, [data]);

  return (
    <Table
      columns={columns}
      dataSource={tableData}
      onRow={(record) => {
        return {
          onClick: () => {
            if (record?.speakingPartCode) {
              history.push(
                `/cbt/speaking-test/${speakingExamCode}/part/${record.speakingPartCode}/edit`,
              );
            }
          },
        };
      }}
      rowClassName="pointer"
      rowKey="speakingPartCode"
    />
  );
};

export default SpeakingPartTable;
